import { render } from "./BlogCategoriesRecipes.vue?vue&type=template&id=fd664aa2&scoped=true"
import script from "./BlogCategoriesRecipes.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesRecipes.vue?vue&type=script&lang=js"

import "./BlogCategoriesRecipes.vue?vue&type=style&index=0&id=fd664aa2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd664aa2"

export default script